import React from 'react';
import NotificationsTable from './NotificationsTable';

export default function PastNotifications({ rows, listLoading }) {
    return (
        <NotificationsTable
            rows={rows}
            listLoading={listLoading}
            showActions={false}
        />
    );
}
